var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.118,
    height: 40,
    viewBox: "0 0 44.118 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7085",
    "data-name": "Groupe 7085",
    transform: "translate(-11.459 -37.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7277",
    "data-name": "Groupe 7277"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9821",
    "data-name": "Trac\\xE9 9821",
    d: "M180.418,197.094l-3.756,2.5-3.793-3.793a4.948,4.948,0,0,0-7,7l3.892,3.892.7,7.211a6.556,6.556,0,0,0,6.5,6.042l3.869.021a6.848,6.848,0,0,0,4.848-1.991l6.866-6.866a6.81,6.81,0,0,0,0-9.621L189,197.943a6.819,6.819,0,0,0-8.585-.849Zm9.506,7.019a3.092,3.092,0,0,1,0,4.373l-6.866,6.866a3.118,3.118,0,0,1-2.2.906l-3.875-.026a2.845,2.845,0,0,1-2.814-2.649l-.273-2.76,2.912,2.912a1.855,1.855,0,1,0,2.624-2.624L168.5,200.177a1.237,1.237,0,0,1,1.749-1.749l4.868,4.868a1.855,1.855,0,0,0,2.341.232l5.021-3.347a3.1,3.1,0,0,1,3.9.387Z",
    transform: "translate(-138.96 -142.775)",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9822",
    "data-name": "Trac\\xE9 9822",
    d: "M26.34,66.955A14.881,14.881,0,1,1,41.222,52.073a1.488,1.488,0,1,1-2.976,0A11.905,11.905,0,1,0,26.34,63.979a1.488,1.488,0,1,1,0,2.976Z",
    fill: "#717171"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9823",
    "data-name": "Trac\\xE9 9823",
    d: "M82.572,119.527a1.487,1.487,0,0,1-.57-.113,8.929,8.929,0,1,1,11.676-11.658,1.488,1.488,0,1,1-2.73,1.185l-.02-.048a5.953,5.953,0,1,0-7.784,7.777,1.488,1.488,0,0,1-.572,2.863Z",
    transform: "translate(-59.083 -59.09)",
    fill: "#717171"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/button.e8571e6e22529ff599b162a934928c75.svg";
export { ForwardRef as ReactComponent };